import { Component, ViewChild } from '@angular/core';
import {
  AppTableComponent,
  RoleModel,
  RolesService,
  SearchModel,
  SearchResultModel,
  TranslationManager,
  RolesInUserModel,
} from 'src/common';

@Component({
  selector: 'roles-select',
  templateUrl: './roles-select.component.html',
})
export class RolesSelectComponent {
  
  constructor(private rolesService: RolesService) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedId: number;
  rolemodels: any[];
  show: boolean = false;
  resolve: any;

  showModal(id:number): Promise<number> {
    this.show = true;
    this.selectedId=id;

    this.table.onSearch = this.doSearch.bind(this);
    this.table.search();

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  doSearch(search: SearchModel) {
    this.rolesService
      .search(search)
      .then((result: SearchResultModel<RoleModel>) => {
        this.rolemodels = result.items;
        this.table.setTotalCount(result.totalCount);
      });
  }

  selectRole(id: number, event) {
    this.selectedId = event.target.checked?id:-1;
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve();
    }
  }

  submit() {
    this.show = false;
    if (this.resolve) {
      this.resolve(this.selectedId);
    }
  }
}
